<div style="width: 37.5rem; overflow-y: auto; max-height: 37.5rem">
  <div style="text-align: right; margin-bottom: -1.375rem">
    <span (click)="closeDialog()" class="closeButton">&#10005;</span>
  </div>
  <div style="margin-top: 1.875rem; text-align: center">
    @if (!data.error) {
      <img src="assets/successcheckmark.svg" />
    }
    @if (data.error) {
      <img src="assets/error.svg" />
    }
  </div>
  <div style="text-align: center">
    @if (!data.error) {
      <span style="color: #00853f; font-size: 1.688rem">Sent to PowerPlan</span>
    }
    @if (data.error && !data.isDOA) {
      <span style="color: rgb(158, 27, 50); font-size: 1.688rem">PowerPlan Submission Failed</span>
    }
    @if (data.error && data.isDOA) {
      <span style="color: rgb(158, 27, 50); font-size: 1.688rem">DOA Retrieval Failed</span>
    }
  </div>
  <div style="text-align: center; padding-top: 1.563rem; width: 31.25rem; margin: auto">
    @if (!data.error && !data.isEstimate) {
      <span style="color: #676767; font-size: 0.875rem"
        >Project #{{ data.data }} will appear in PowerPlan after the closest system refresh at 10:00
        AM, 2:00 PM, or 6:00 PM</span
      >
    }
    @if (!data.error && data.isEstimate) {
      <span style="color: #676767; font-size: 0.875rem"
        >The Estimate information of Project #{{ data.data }} will appear in PowerPlan after the
        closest system refresh at 6:00 PM.</span
      >
    }
    @if (data.error && !data.isDOA) {
      <div>
        <div style="padding-bottom: 0.313rem">
          <span style="color: #676767; font-size: 0.875rem"
            >Save failed with the following errors:</span
          >
        </div>
        @for (errorMessage of data.data; track errorMessage) {
          <div style="padding-bottom: 0.313rem">
            <span style="color: #676767; font-size: 0.875rem">{{ errorMessage }}</span>
          </div>
        }
      </div>
    }
    @if (data.error && data.isDOA) {
      <div>
        <div style="padding-bottom: 0.313rem">
          <span style="color: #676767; font-size: 0.875rem"
            >DOA retrieval failed with the following error:</span
          >
        </div>
        <div style="padding-bottom: 0.313rem">
          <span style="color: #676767; font-size: 0.875rem">{{ data.data }}</span>
        </div>
      </div>
    }
  </div>
  @if (!data.error) {
    <div style="text-align: center">
      <button
        class="returnButton"
        style="margin-top: 1.25rem; margin-right: 1.25rem"
        (click)="goToDashboard()"
      >
        <span class="returnText">GO TO DASHBOARD</span>
      </button>
      <button class="confirmButton" (click)="goToProjectSetup()">
        <span class="confirmText">NEW PROJECT SETUP</span>
      </button>
    </div>
  }
  @if (data.error) {
    <div style="text-align: center">
      <button class="okButton" (click)="closeDialog()">
        <span class="buttonText">OK</span>
      </button>
    </div>
  }
</div>
